<template>
  <div>
    <l-container>
      <ul class="childNav">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="nav==index ? 'activeNav' : ''"
          @click="handNav(item,index)"
        >{{item.name}}</li>
      </ul>
      <router-view />
    </l-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: 0,
      level: JSON.parse(localStorage.getItem("userinfo"))?.level,
      navList: [],
      list: [
        { name: "待测评问卷", path: "/question" },
        { name: "问卷题库", path: "/question/back", level: [1,2] },
        { name: "发布问卷", path: "/question/publish", level: [1,2,3] },
        { name: "扫码测评", path: "/question/code" },
        { name: "问卷结果", path: "/question/result" },
      ],
    };
  },
  methods: {
    handNav(item, index) {
      this.nav = index;
      this.$router.push(item.path);
    },
  },
  //路由守卫
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.navList = vm.list.filter((item) => {
        if ('level' in item) {
          return item.level.indexOf(vm.level) > -1
        } else {
          return true
        }
      });
      vm.navList.forEach((item, index) => {
        if (item.path == to.path) {
          vm.nav = index;
        }
      });
    });
  },
};
</script>

<style lang='less' scoped>
.childNav {
  display: flex;
  color: #fff;
  font-size: 18px;
  li {
    width: 130px;
    height: 50px;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    margin-right: 10px;
  }
  .activeNav {
    background: #3170ff;
  }
}
</style>